
(ns app.strive-forms.question-fields.multi-select
  (:require [app.components.icons.views :refer [close-icon]]
            [app.components.tables.styles :refer [close-icon-span-style]]
            [app.strive-forms.component-multi-methods :refer [calc-error-message
                                                              show-action-btn? update-question-input-data update-question-input-local]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as events]
            [app.strive-forms.helper-functions :refer [check-question-visibility color-condition
                                                       component-alignment disable-continue-button enable-continue-button generate-alphabet
                                                       get-error-message-color maybe-scroll-down! on-focus-toggle
                                                       scroll-to-next-required-field! set-values-for-button!]]
            [app.strive-forms.question-components :refer [letter-checkbox]]
            [app.strive-forms.styles :refer [list-group-item-style
                                             list-group-item-text-style num-input-style
                                             responsive-input-field-border-class responsive-input-field-style
                                             selection-list-style warning-notification]]
            [clojure.string :as s :refer [lower-case]]
            [goog.string :as gstring]
            [goog.string.format]
            [keybind.core :as key]
            [re-com.core :as re-com :refer [at h-box v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.material.box :refer [box]]
            [reagent-mui.material.list :refer [list]]
            [reagent-mui.material.list-item-button :refer [list-item-button]]
            [reagent-mui.material.list-item-text :refer [list-item-text]]
            [reagent-mui.material.text-field :refer [text-field]]
            [reagent-mui.styles :refer [create-theme theme-provider]]
            [reagent.core :as r]))

(def multi-select-theme
  (create-theme
   {:palette {:primary {:main (:primary (:themes default-values))}}
    :typography {:fontFamily ["'Nunito Sans' "]}}))

(defmethod show-action-btn? "multi_select" [_]
  true)

(defn- get-range-invalid-error-msg [{:keys [range-invalid-message form-messages min-limit max-limit]}]
  (gstring/format (:range_invalid form-messages range-invalid-message) min-limit max-limit))

(defmethod calc-error-message "multi_select" [{:keys [settings form-messages range-valid?]}]
  (let [range-invalid-message (:range-invalid (:multi_select (:errors default-values)))]
    (cond
      (and (not range-valid?) (:allow_multiple settings) (some? (first (:count_range settings))) (some? (last (:count_range settings))))
      (get-range-invalid-error-msg {:range-invalid-message range-invalid-message :form-messages form-messages
                                    :min-limit (first (:count_range settings))
                                    :max-limit (last (:count_range settings))})

      :else "")))

(defn range-valid-fn? [selected-values range-allowed count-other?]
  (let [currently-selected (+ (count selected-values) count-other?)]
    (not (and
          (> currently-selected 0)
          (not (<= (first range-allowed) currently-selected (last range-allowed)))))))

(defn button-disabled-fn? [range-valid? settings selected-values count-other? text-val]
  (or (false? @range-valid?)
      (or
       (and (zero? (count @selected-values)) (= @count-other? 1) (s/blank? @text-val))
       (zero? (+ (count @selected-values) @count-other?)))))

(defmethod update-question-input-local "multi_select" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::events/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))


(defmethod update-question-input-data "multi_select" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))

#_(defn- process-response! [{:keys [input-data field-id regenerate-display-fields selections input-value allow-multiple? button-ids-for-button]}]
    (re-frame/dispatch [::events/update-input-local
                        {:input-data input-data :key (keyword field-id) :value selections}])
    (regenerate-display-fields
     (update input-data (keyword field-id) (fn [value]
                                             (assoc value
                                                    :value selections))))
    (set-values-for-button! {:input-value input-value :component-input-value (r/atom selections)
                             :field-id field-id :type "multi_select"})

    (if (empty? selections)
      (disable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})
      (enable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})))

(defn- process-response! [{:keys [input-data field-id regenerate-display-fields selections input-value allow-multiple? button-ids-for-button missing-required-fields
                                  current-page is-multi-question? steps-total]}]
  (if allow-multiple?
    (do
      (update-question-input-local {:field-id field-id
                                    :input-data input-data
                                    :type "multi_select"
                                    :input-value selections})
      (regenerate-display-fields
       (update input-data (keyword field-id) (fn [value]
                                               (assoc value
                                                      :value selections))))
      (set-values-for-button! {:input-value input-value :component-input-value (r/atom selections)
                               :field-id field-id :type "multi_select"})
      (if (empty? selections)
        (disable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})
        (enable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})))
    (do (re-frame/dispatch [::events/update-input-local
                            {:input-data input-data :key (keyword field-id) :value selections}])
        (regenerate-display-fields
         (update input-data (keyword field-id) (fn [value]
                                                 (assoc value
                                                        :value selections))))
        (when-not (zero? (count @missing-required-fields))

          (scroll-to-next-required-field! {:missing-required-fields missing-required-fields :field-id field-id
                                           :current-page current-page :is-multi-question? is-multi-question?
                                           :steps-total steps-total})))))

(defn on-text-change-action [{:keys [text-val value new-session]}]
  (reset! text-val value)
  (when @new-session (swap! new-session not)))

(defn- extract-values-selected [{:keys [selections multi-select-items]}]
  (mapv :value
        (filter #(contains? @selections (:id %))
                @multi-select-items)))

(defn select-based-on-key-down [{:keys [multi-select-items selections letter settings regenerate-display-fields field-id input-data
                                        additional-text input-value button-ids-for-button missing-required-fields current-page is-multi-question? steps-total]}]
  (fn []
    (let [id-of-item (->> @multi-select-items
                          (filter #(= (lower-case (first (:label %))) letter))
                          (first)
                          :id)]
      (reset! selections (if (:allow_multiple settings)
                           (if (contains? @selections id-of-item)
                             (disj @selections id-of-item)
                             (conj @selections id-of-item))
                           (if (contains? @selections id-of-item)
                             (disj #{} id-of-item)
                             (conj #{} id-of-item))))
      (process-response! {:input-data input-data :field-id field-id
                          :regenerate-display-fields regenerate-display-fields
                          :selections (extract-values-selected {:selections selections
                                                                :multi-select-items multi-select-items})
                          :additional-text additional-text
                          :input-value input-value
                          :allow-multiple? (:allow_multiple settings)
                          :button-ids-for-button button-ids-for-button
                          :missing-required-fields missing-required-fields
                          :current-page current-page :is-multi-question? is-multi-question?
                          :steps-total steps-total}))))

(defn keyboard-listener-on! [{:keys [multi-select-items selections letters settings
                                     input-data field-id regenerate-display-fields additional-text input-value button-ids-for-button missing-required-fields current-page is-multi-question? steps-total]}]
  (doseq [letter letters]
    (key/bind! letter ::my-trigger (select-based-on-key-down {:multi-select-items multi-select-items
                                                              :selections selections :letter letter
                                                              :settings settings
                                                              :regenerate-display-fields regenerate-display-fields
                                                              :field-id field-id :input-data input-data
                                                              :additional-text additional-text
                                                              :input-value input-value
                                                              :button-ids-for-button button-ids-for-button
                                                              :missing-required-fields missing-required-fields
                                                              :current-page current-page :is-multi-question? is-multi-question?
                                                              :steps-total steps-total}))
    (key/bind! (s/upper-case letter) ::my-trigger
               (select-based-on-key-down {:multi-select-items multi-select-items
                                          :selections selections :letter (s/upper-case letter)
                                          :button-ids-for-button button-ids-for-button
                                          :missing-required-fields missing-required-fields
                                          :current-page current-page :is-multi-question? is-multi-question?
                                          :steps-total steps-total}))))

(defn keyboard-listener-off! [{:keys [letters]}]
  (doseq [letter letters]
    (key/unbind! letter ::my-trigger)))



(defn select-from-options! [{:keys [settings selections item input-data field-id regenerate-display-fields multi-select-items
                                    additional-text input-value button-ids-for-button missing-required-fields current-page is-multi-question? steps-total event index]}]
  (reset! selections (if (:allow_multiple settings)
                       (if (contains? @selections (:id item))
                         (disj @selections (:id item))
                         (conj @selections (:id item)))
                       (if (contains? @selections (:id item))
                         (disj #{} (:id item))
                         (conj #{} (:id item)))))
  (when (contains? @selections (:id item))
    (maybe-scroll-down! {:event event :index index
                         :bottom-percentage-of-page (:scroll-down-condition default-values)}))

  (process-response! {:input-data input-data :field-id field-id
                      :regenerate-display-fields regenerate-display-fields
                      :selections (extract-values-selected {:selections selections
                                                            :multi-select-items multi-select-items})
                      :additional-text additional-text
                      :input-value input-value
                      :allow-multiple? (:allow_multiple settings)
                      :button-ids-for-button button-ids-for-button
                      :missing-required-fields missing-required-fields
                      :current-page current-page :is-multi-question? is-multi-question?
                      :steps-total steps-total}))

(defn select-other-option! [count-other? show-other? multi-select-items selections]
  (reset! count-other? 1)
  (swap! show-other? not)
  (reset! multi-select-items (remove #(= 1 (:id %)) @multi-select-items))
  (swap! selections disj 1))

(defn- readd-letter-for-other [letters]
  (str
   (s/upper-case (last letters))
   ". "
   (:other-label default-values)))

(defn deselect-other-option! [{:keys [count-other? show-other? hide-other-field? multi-select-items letters]}]
  (reset! count-other? 0)
  (swap! show-other? not)
  (reset! hide-other-field? false)
  (reset! multi-select-items (conj (vec @multi-select-items) {:id 1 :value (:other-label default-values)
                                                              :label (readd-letter-for-other letters) :order nil})))

(defn maybe-select-other-option! [{:keys [selections show-other? multi-select-items count-other? hide-other-field? letters]}]
  (cond (and (contains? @selections 1) (false? @hide-other-field?))
        (select-other-option! count-other? show-other? multi-select-items selections)
        (and (true? @hide-other-field?) (= @count-other? 1))
        (deselect-other-option! {:count-other? count-other? :show-other? show-other? :hide-other-field? hide-other-field?
                                 :multi-select-items multi-select-items :letters letters})))

(defn hide-icon-for-other [{:keys [hide-other-field? text-val selections show-other? multi-select-items count-other? letters]}]
  [:span {:class (close-icon-span-style)
          :onClick (fn []
                     (reset! hide-other-field? true)
                     (reset! text-val "")
                     (maybe-select-other-option! {:selections selections :show-other? show-other?
                                                  :multi-select-items multi-select-items
                                                  :count-other? count-other?
                                                  :hide-other-field? hide-other-field?
                                                  :letters letters}))}
   [close-icon {:size "18px"}]])

(defn other-text-field [{:keys [text-val form-messages theme-data hide-other-field? selections show-other?
                                multi-select-items count-other? on-focus new-session letters]}]
  [h-box :src (at)
   :align :center
   :justify :start
   :width (:width-for-other-text-field default-values)
   :children [[:div
               {:class
                (responsive-input-field-style {:input-font-color (color-condition {:valid? true
                                                                                   :on-focus false
                                                                                   :theme-data nil
                                                                                   :default-color (:light-gray (:themes default-values))})
                                               :title-field-color (:buttons_color theme-data)
                                               :border-color (color-condition {:valid? true
                                                                               :on-focus @on-focus
                                                                               :theme-data theme-data
                                                                               :default-color (:dark-gray (:themes default-values))})})}
               [h-box
                :class (responsive-input-field-border-class {:border-color (color-condition {:valid? true
                                                                                             :on-focus @on-focus
                                                                                             :theme-data theme-data
                                                                                             :default-color (:dark-gray (:themes default-values))})
                                                             :border-size (str (if @on-focus "2px" "1px") " solid")
                                                             :margin (when @on-focus "-1px")
                                                             :width "100%"})
                :children [[box {:sx {:display "flex" :alignItems "flex-end"}}
                            [text-field {:variant "filled"
                                         :class (num-input-style)
                                         :style {:background "transparent"}
                                         :max-rows 1
                                         :model          @text-val
                                         :InputProps  {:disableUnderline true}
                                         :label (:multi_select_other_input_label form-messages (:multi_select_other_input_label default-values))
                                         :auto-focus true
                                         :on-focus (do (on-focus-toggle on-focus)
                                                       (keyboard-listener-off! {:letters letters}))
                                         :on-change (fn [x]
                                                      (on-text-change-action {:text-val text-val :value (-> x .-target .-value)
                                                                              :new-session new-session}))
                                         :on-blur (on-focus-toggle on-focus)}]]]]]
              [hide-icon-for-other {:hide-other-field? hide-other-field? :text-val text-val :selections selections
                                    :show-other? show-other? :multi-select-items multi-select-items :count-other? count-other?
                                    :letters letters}]]])

(defn get-selected-values [multi-select-items selections]
  (->> (filter #(not= (:id %) 1) (filter (comp selections :id) multi-select-items))
       (mapv :value)))

(defn add-letters-to-labels [data letters]
  (map-indexed (fn [index m]
                 (let [label (:value m)]
                   (assoc m :label (str (s/upper-case (nth letters index)) ". " label))))
               data))

(defn add-other-to-options-list [data imply_other?]
  (if imply_other?
    (conj data {:id 1 :value (:other-label default-values) :order nil})
    data))

(defn- margin-for-list-item [id]
  (if (= 1 id) "nil" "8px 0"))

(defn- border-size-for-list-item [selections item]
  (if (contains? @selections (:id item)) "2px solid " "1px solid "))

(defn- border-color-for-list-item [selections item theme-data]
  (if (contains? @selections (:id item)) (:buttons_color theme-data) (:answers_border_color theme-data "#9c9ea8")))

(defn multi-select-list [{:keys [selections multi-select-items settings theme-data show-other? text-val language-direction
                                 form-messages hide-other-field? count-other? on-focus new-session letters selected-language
                                 input-data field-id regenerate-display-fields index additional-text input-value button-ids-for-button
                                 missing-required-fields current-page is-multi-question? steps-total]}]
  [:div
   [:<>
    [list {:sx {:width "100%" :maxWidth 360}
           :class (selection-list-style)}
     (doall (map (fn [item]
                   ^{:key (str "list-item-" (:id item))}
                   [theme-provider  multi-select-theme
                    [list-item-button  {:role "undefined"
                                        :disableRipple true
                                        :dense true
                                        :onClick (fn [event]
                                                   (select-from-options! {:settings settings :selections selections :item item
                                                                          :input-data input-data :field-id field-id
                                                                          :regenerate-display-fields regenerate-display-fields
                                                                          :multi-select-items multi-select-items
                                                                          :missing-required-fields missing-required-fields
                                                                          :current-page current-page :is-multi-question? is-multi-question?
                                                                          :steps-total steps-total :event event :index index
                                                                          :additional-text additional-text :input-value input-value :button-ids-for-button button-ids-for-button})
                                                   (reset! new-session false))
                                        :class (list-group-item-style  {:background-color (str (:answers_background_color theme-data) "60")
                                                                        :border-color (border-color-for-list-item selections item theme-data)
                                                                        :answer-color (:answers_color theme-data)
                                                                        :border-size (border-size-for-list-item selections item)
                                                                        :text-align (if (= language-direction "RTL") "right" "left")
                                                                        :margin (margin-for-list-item (:id item))})}
                     (letter-checkbox {:letter (first (:label item))
                                       :fill-color (border-color-for-list-item selections item theme-data)
                                       :condition-to-fill-color (contains? @selections (:id item))
                                       :neutral-color "white"
                                       :border-color-for-letter (:answers_color theme-data)
                                       :text-color "white"})
                     [list-item-text {:id (str "labelId" (:id item))
                                      :key (str "labelId" (:id item))
                                      :primary (get (:option_texts item) (keyword selected-language))
                                      :class (list-group-item-text-style {:answer-color (:answers_color theme-data)})}]]]) @multi-select-items))]]
   (when @show-other?
     [other-text-field {:text-val text-val :form-messages form-messages :theme-data theme-data
                        :hide-other-field? hide-other-field? :selections selections :show-other? show-other?
                        :multi-select-items multi-select-items :count-other? count-other? :on-focus on-focus
                        :new-session new-session :letters letters}])])

(defn multi-select-field [{:keys [field field-id input-data visible? default-value]
                           {:keys [additional_settings is_required multi_select_items]} :field}]

  (let [text-val (r/atom (:value (get input-data (keyword field-id))))
        settings (assoc additional_settings :is_required is_required)
        multi-with-other (add-other-to-options-list multi_select_items (:imply_other settings))
        letters (generate-alphabet (count multi-with-other))
        multi-select-items (r/atom (vec (add-letters-to-labels multi-with-other letters)))
        show-other? (r/atom false)
        hide-other-field? (r/atom false)
        on-focus (r/atom false)
        new-session (r/atom true)
        default-value-id-in-list (some #(when (= default-value (:value %)) (:id %)) @multi-select-items)
        selections     (r/atom (if (some? default-value-id-in-list) #{default-value-id-in-list} #{}))
        count-other? (r/atom 0)]
    (when @visible?
      (fn [{:keys [theme-data form-messages error-fn-props input-value regenerate-display-fields language-direction
                   additional-text current-page index is-multi-question? input-data button-ids-for-button selected-language missing-required-fields steps-total]}]
        (check-question-visibility {:index index :current-page current-page :visible? visible?})
        (when (false? is-multi-question?)
          (if @visible?
            (keyboard-listener-on! {:multi-select-items multi-select-items :selections selections :letters letters :settings settings
                                    :input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields
                                    :additional-text additional-text :input-value input-value
                                    :button-ids-for-button button-ids-for-button
                                    :missing-required-fields missing-required-fields
                                    :current-page current-page :is-multi-question? is-multi-question?
                                    :steps-total steps-total})
            (keyboard-listener-off! {:letters letters})))
        (let [selected-values (r/atom (get-selected-values @multi-select-items @selections))
              range-valid? (r/atom (range-valid-fn? @selections (:count_range settings) @count-other?))
              multi-select-valid? (r/atom true)
              multi-select-button-disabled? (r/atom true)]
          #_(update-preview-panel! {:input-data input-data :field-id field-id
                                    :value-to-update @selected-values
                                    :condition (not (empty? @selections))})
          (maybe-select-other-option! {:selections selections :show-other? show-other? :multi-select-items multi-select-items
                                       :count-other? count-other? :hide-other-field? hide-other-field? :letters letters})
          (reset! multi-select-button-disabled? (button-disabled-fn? range-valid? settings selected-values count-other? text-val))
          (reset! additional-text @text-val)
          [v-box
           :width "350px"
           :align (component-alignment is-multi-question?)
           :justify :center
           :style {:align-self (component-alignment is-multi-question?)}
           :children [[multi-select-list {:selections selections :multi-select-items multi-select-items :settings settings
                                          :theme-data theme-data :show-other? show-other? :text-val text-val :language-direction language-direction
                                          :form-messages form-messages :hide-other-field? hide-other-field? :selected-language selected-language
                                          :count-other? count-other? :on-focus on-focus :new-session new-session :letters letters
                                          :input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields
                                          :index index :additional-text additional-text :input-value input-value :button-ids-for-button button-ids-for-button
                                          :missing-required-fields missing-required-fields
                                          :current-page current-page :is-multi-question? is-multi-question?
                                          :steps-total steps-total}]
                      [:div {:class (warning-notification {:width "350px"
                                                           :color (get-error-message-color new-session)
                                                           :align (component-alignment is-multi-question?)})}
                       (calc-error-message {:settings settings :input-value input-value :valid? multi-select-valid?
                                            :type "multi_select" :range-valid? @range-valid? :field field
                                            :form-messages form-messages :error-fn-props error-fn-props
                                            :new-session new-session})]]])))))
